import { Typography } from '@mui/material';
import React from 'react';
import {
  BooleanInput,
  Create,
  required,
  SelectInput,
  SimpleForm,
  TextInput,
} from 'react-admin';
import {
  ClientCalendarPlatform,
  ClientVideoPlatform,
  Prefix,
} from '../../../graphql/types';
import ImageUploadInput from '../components/ImageUploadInput';
import * as Labels from './labels';

const DisplayNameInput: React.FC = () => {
  const charLimit = 20;
  return (
    <TextInput
      source="displayName"
      label="Display Name"
      helperText="This will be seen by app users (max 20 char)"
      inputProps={{ maxLength: charLimit }}
      style={{ marginBottom: 26 }}
      validate={required()}
    />
  );
};

export const ClientCreate: React.FC = () => (
  <Create>
    <SimpleForm>
      <Typography variant="subtitle2" style={{ marginBottom: 30 }}>
        Additional configuration options become available after you save.
      </Typography>
      <TextInput source="name" label="Client Name" />
      <DisplayNameInput />
      <SelectInput
        label="Calendar Platform"
        source="calendarPlatform"
        choices={Object.entries(ClientCalendarPlatform).map(([name, id]) => ({
          id,
          name,
        }))}
        validate={required()}
        defaultValue={ClientCalendarPlatform.Google}
      />
      <SelectInput
        label="Video Platform"
        source="videoPlatform"
        choices={Object.entries(ClientVideoPlatform).map(([name, id]) => ({
          id,
          name,
        }))}
        validate={required()}
        defaultValue={ClientVideoPlatform.Integrated}
      />
      <ImageUploadInput
        source="logo"
        prefix={Prefix.Uploads}
        label="Client Logo"
        helperText={false}
      />
      <BooleanInput
        source="isFcmOnly"
        label={Labels.IS_FCM_ONLY}
        helperText={Labels.IS_FCM_ONLY_HELPER_TEXT}
      />
      <BooleanInput
        source="usesCustomChallenges"
        label="Members Can Create Custom Challenges"
        defaultValue
      />
    </SimpleForm>
  </Create>
);
